import { render, staticRenderFns } from "./CabinetPowerPriceModal.vue?vue&type=template&id=344c6dd4&"
import script from "./CabinetPowerPriceModal.vue?vue&type=script&lang=js&"
export * from "./CabinetPowerPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports